package com.bikompanion.domain.usecase

import dev.zacsweers.metro.Inject
import com.bikompanion.domain.BikeIssue
import com.bikompanion.domain.BikeKey
import com.bikompanion.domain.BikeRatingRepository
import com.bikompanion.domain.BikeScopeSource
import com.bikompanion.domain.SubmitVoteResult
import com.bikompanion.domain.analytics.AnalyticsTracker
import com.bikompanion.domain.analytics.DomainAnalyticsEvents

@Inject
class SubmitBikeVoteUseCase(
    private val ratingRepository: BikeRatingRepository,
    private val analytics: AnalyticsTracker,
) {
    suspend operator fun invoke(
        key: BikeKey,
        isPositive: Boolean,
        isElectric: Boolean,
        issues: List<BikeIssue>,
        scopeSource: BikeScopeSource,
    ): SubmitVoteResult =
        ratingRepository.submitVote(key, isPositive, isElectric, issues, scopeSource).also { result ->
            analytics.track(
                DomainAnalyticsEvents.bikeVoteSubmitted(key, isPositive, isElectric, issues, scopeSource, result),
            )
        }
}
